import { render, staticRenderFns } from "./сollapsible.vue?vue&type=template&id=662a0bc9&scoped=true"
import script from "./сollapsible.vue?vue&type=script&lang=js"
export * from "./сollapsible.vue?vue&type=script&lang=js"
import style0 from "./сollapsible.vue?vue&type=style&index=0&id=662a0bc9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a0bc9",
  null
  
)

export default component.exports